export default __webpack_public_path__ + "static/media/56_3_1.9c5f0f71.png";